module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-25.71ca4210.svg";